import { useMapCanvas } from '../contexts/MapCanvasContext';
import { generateNextSpotLabels } from '../helpers/generateNextSpotLabels';

export const useSpotLabelIterator = () => {
  const { lastSpotLabel, setLastSpotLabel, spotLabelPattern } = useMapCanvas();

  const next = (updateCurrent = true): string[] => {
    const nextNumber = generateNextSpotLabels(
      spotLabelPattern,
      lastSpotLabel || []
    );

    if (updateCurrent) setLastSpotLabel(nextNumber);

    return nextNumber || [];
  };

  return { next };
};
